
import { defineComponent } from "vue";

export default defineComponent({
  name: "Sidebar",
  props: {},
});
